<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        title='工单编辑'
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='500'
        :fullscreen='$isMobile'
      >
      <template v-slot:content>
        <v-card class="px-5" elevation="0">
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12" md="12">
                <v-select-search
                  hide-details
                  outlined
                  label="年份选择"
                  :data='yearItems'
                  item-text="label"
                  item-value="value"
                  v-model='form.doYear'>
                </v-select-search>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea outlined  rows='3' v-model="form.remark" label="备注"></v-textarea>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { save } from '@/api/order/index.js'
  import { selectData2 } from '@/utils/tool.js'
  import VSelectSearch from '@/components/select/v-select-search.vue'

  export default {
    name: 'OrderEdit',
    components: {
      VSelectSearch
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        number: [
          value => /^[0-99]*$/.test(value) || '此项为必填项',
        ],
        array: [
          value => value.length > 0 || '此项为必填项!'
        ],
        yearItems: selectData2(),
        form: {
          id: '',
          doYear: '',
          remark: ''
        },
        defForm: {
          id: '',
          doYear: '',
          remark: ''
        }
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      dialogChange (val) {
        this.item.show = val
        if (val && this.isEdit) {
          this.form.remark = this.item.data.remark
          this.form.id = this.item.data.id
          this.form.doYear = this.item.data.doYear || this.item.data.contract.year
        } else {
          this.form = JSON.parse(JSON.stringify(this.defForm))
        }
      },
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
